import { render, staticRenderFns } from "./ControlAccessCards.vue?vue&type=template&id=09f83055&"
import script from "./ControlAccessCards.vue?vue&type=script&lang=js&"
export * from "./ControlAccessCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports